<template>
  <div v-if="model">
    <h2 class="title is-5">
      <d-previous-btn
        :path="'/properties/' + $route.params.property + '/application-files/'+ $route.params.applicationFile"
      />
      {{ model.first_name }} {{ model.last_name }}
    </h2>

    <d-card class="mb-0">
      <d-card-row>
        <VApplicantSteps
          v-if="model"
          :applicant="model"
          :loading="loading"
          :application-file="model.application_file"
          @success="query"
        />
      </d-card-row>
    </d-card>
  </div>
</template>

<script>
import ApplicantSteps from "@/shared/applicant/ApplicantSteps";

export default {
  components: {
    "VApplicantSteps": ApplicantSteps,
  },
  metaInfo() {
    return {
      title: this.title,
      __applicant: this.title
    };
  },
  data () {
    return {
      model: null,
      loading: true
    };
  },
  computed: {
    title () {
      if (this.model) {
        return this.model.first_name + " " + this.model.last_name;
      }
      return "";
    }
  },
  created () {
    this.query();
  },
  methods: {
    query() {
      this.$http.get(this.$laravel.route("api.applicants.show", {
        property: this.$route.params.property,
        application_file: this.$route.params.applicationFile,
        applicant: this.$route.params.applicant
      }))
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
          this.$router.push("/properties/" + this.$route.params.property + "/application-files/" + this.$route.params.applicationFile);
        });
    }
  },
};
</script>
